<template>
  <v-menu
    v-model="open"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :disabled="disabled"
        :label="label"
        :rules="rules"
        :value="value"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      :locale="'ru'"
      :min="minDate"
      :max="maxDate"
      :type="type"
      :value="value"
      @input="handleInput"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',

  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    maxDate: {
      type: String,
      required: false,
    },
    minDate: {
      type: String,
      required: false,
    },
    rules: {
      type: Array,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    value: {
      type: String,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    handleInput(value) {
      this.open = false;
      this.$emit('input', value);
    },
  },
};
</script>
